import { FunctionComponent, PropsWithChildren, useMemo } from 'react';

import { mapPlatformDtoToItemLabelModel } from '../../../features/shared/utils/mapping/mapping.utils';
import { getPlatforms } from '../../thunks/get-platforms/get-platforms.thunk';
import { WithOptionsModel } from '../with-options/models/with-options.model';
import { withOptions } from '../with-options/with-options';

const withPlatformOptions = <TProps,>(
  Component: FunctionComponent<TProps & WithOptionsModel>
): FunctionComponent<TProps & WithOptionsModel> => {
  return (props: PropsWithChildren<TProps & WithOptionsModel>) => {
    const WrappedComponent = useMemo(
      () =>
        withOptions(Component, {
          dispatchFn: getPlatforms,
          mapper: mapPlatformDtoToItemLabelModel,
          thunkArgs: undefined,
        }),
      []
    );

    return <WrappedComponent {...props} />;
  };
};

export default withPlatformOptions;
